import { t } from "@lingui/macro"
import { i18n } from "@lingui/core"
import { Button, ButtonsContainer, Icon, ModalBody } from "@silversea-ssc/ui-components-react"
import React, { ReactElement } from "react"
import clsx from "clsx"
import styles from "./ErrorBox.module.scss"
import styles2 from "./Modal.module.scss"

type ButtonProps = {
    onClick: () => void
    label: string | ReactElement
}

interface ErrorBoxProps {
    title?: string | ReactElement
    message?: string | ReactElement
    button?: ButtonProps
    hideIcon?: boolean
}

// NOTE: The goal of this component is to work as a 500 page in NextJs since it's rendered only
// on the server side. It should not have any client side hooks like useEffect/useState/portals
// which react-modal uses.

// NOTE 2: This component is also used within the Root ErrorBoundary component.
// Within this component We CANNOT use the Trans macro since it's a child
// of a class component (ErrorBoundary).

const DefaultTitle: React.FC = () =>
    i18n._("error-box-title", {
        message: "It looks like there's a problem with the system",
    })

const ErrorBox: React.FC<React.PropsWithChildren<ErrorBoxProps>> = ({
    title = <DefaultTitle />,
    message,
    button,
    hideIcon = false,
}) => {
    return (
        <div className={clsx(styles2.overlay, styles2.overlayAfterOpen)}>
            <div className={clsx(styles2.content, styles2.contentSmall)}>
                <ModalBody variant="full" className={styles.modalBodyWrapper}>
                    <div className={styles.errorIconContainer}>
                        {!hideIcon && (
                            <React.Fragment>
                                <Icon name="alert" size="2x" padding="inline" /> {t`Error in processing your request`}
                            </React.Fragment>
                        )}
                    </div>
                    <div className={styles.modalContent}>
                        <div className={styles.title}>{title}</div>
                        <div className={styles.body}>{message}</div>

                        {button && (
                            <div className={styles.buttonsContainer}>
                                <ButtonsContainer mobileFullSize>
                                    <Button
                                        size="regular"
                                        variant="primary"
                                        onClick={button.onClick}
                                        full
                                        dataContentPiece="error_button"
                                    >
                                        {button.label}
                                    </Button>
                                </ButtonsContainer>
                            </div>
                        )}
                    </div>
                </ModalBody>
            </div>
        </div>
    )
}

export default ErrorBox
